module.exports = __webpack_public_path__ + "img/full6-min.dfb81a30.png";